import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

// Page Container - specific to properties page (matching companies page)
export const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5),
  },
}));

// Header section containing title and action button (matching companies page)
export const PageHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(1),
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
  },
}));

// Title section with fixed width (matching companies page)
export const TitleSection = styled(Box)(() => ({
  flex: '0 0 25%',
}));

// Button container with responsive positioning (matching companies page)
export const ActionButtonContainer = styled(Box)(({ theme }) => ({
  marginLeft: 'auto',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

// Create site button with consistent styling (matching companies page)
export const CreateSiteButton = styled(Button)(({ theme }) => ({
  minWidth: '50%',
  height: '40px',
  textTransform: 'none',
  borderRadius: theme.spacing(3),
  fontWeight: 600,
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    height: '40px',
  },
}));
